import * as React from 'react';

import {
  enumFacilitySortOption,
  enumRoleSortOption,
  FacilitySortOption,
  RoleSortOption,
} from '@rematter/frontend-lib-api-client';
import { atomWithDebounce, DataGridSelection } from '@rematter/ui-web';
import { atom } from 'jotai';

// Tab types for Team & Permissions module
export const teamPermissionsTabs = ['facilities', 'roles', 'users'] as const;
export type TeamPermissionsTab = (typeof teamPermissionsTabs)[number];

// Search term atom with debounce for the active tab
export const $teamPermissionsSearchTerm = atomWithDebounce('', 300);

// Selected entity IDs for bulk actions (using DataGridSelection for compatibility)
export const $selectedFacilityKeys = atom<DataGridSelection>(
  new Set<React.Key>(),
);
export const $selectedRoleIds = atom<string[]>([]);
export const $selectedUserIds = atom<string[]>([]);

// Facilities table pagination atoms
export const $facilitiesOffset = atom<number>(0);
export const $facilitiesLimit = atom<number>(20);

// Facilities table sorting atom
export const $facilitiesSorting = atom<FacilitySortOption[]>([
  enumFacilitySortOption.NameAsc,
]);

// Roles table pagination atoms
export const $rolesOffset = atom<number>(0);
export const $rolesLimit = atom<number>(20);

// Roles table sorting atom
export const $rolesSorting = atom<RoleSortOption[]>([
  enumRoleSortOption.NameAsc,
]);

// Roles table filter: show archived roles
export const $showArchivedRoles = atom<boolean>(true);

// Users table pagination atoms
export const $usersOffset = atom<number>(0);
export const $usersLimit = atom<number>(20);

// Filter atoms for Users tab
export const $facilityFilter = atom<string[]>([]);
export const $rolesFilter = atom<string[]>([]);
